import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

import { horizontalGutterSize, verticalGutterSize } from './Common';

interface IFixedRightColumn {
  marginFlexRow?: string;
  marginFlexColumn?: string;
}

export const FixedRightColumn = Styled.aside<IFixedRightColumn>`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  margin: ${props => props.marginFlexColumn};

  ${props => media.mediumLarge`
    flex: 0 0 23.75em; /* 380px */
    margin: ${props.marginFlexRow};
  `}
`;

FixedRightColumn.defaultProps = {
  marginFlexRow: `0 0 0 ${verticalGutterSize}`,
  marginFlexColumn: `${horizontalGutterSize} 0 0 0`,
};

export const ResponsiveWideColumn = Styled.article`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;

  ${media.mediumLarge`
    flex: 1 1;
  `}
`;
